import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Match } from '../../models/interfaces/Match';
import { MatchSegmentStats } from '../../models/interfaces/Stat';
import TeamMatchSummaryView from './TeamMatchSummary';
import MatchPlayerSummary from './MatchPlayerSummary';

interface Props {
    match: Match;
    statList: MatchSegmentStats[];
}

export default function MatchSummaryView({ match, statList }: Props) {
    const teamSummaries = match.fanViewConfiguration.teamSummaries(statList).map((teamSummary) => {
        return {
            title: teamSummary.title,
            lightCapTextComponents: teamSummary.displayTextForStats(teamSummary.lightCapStats, teamSummary.darkCapStats),
            darkCapTextComponents: teamSummary.displayTextForStats(teamSummary.darkCapStats, teamSummary.lightCapStats),
        };
    });
    const playerSummaries = match.fanViewConfiguration
        .playerSummaries(statList)
        .map((playerSummary) => {
            return {
                title: playerSummary.title,
                lightCapPlayers: playerSummary.lightCapPlayerArray.map((lightCapPlayerItem) => {
                    return {
                        player: lightCapPlayerItem.player,
                        textComponents: playerSummary.displayTextForStats(lightCapPlayerItem.stats),
                    };
                }),
                darkCapPlayers: playerSummary.darkCapPlayerArray.map((darkCapPlayerItem) => {
                    return {
                        player: darkCapPlayerItem.player,
                        textComponents: playerSummary.displayTextForStats(darkCapPlayerItem.stats),
                    };
                }),
            };
        });

    // const parentCompetition = match.competition;
    // const history = useHistory();
    return (
        <>
            <Row>
                <Col xs={12} sm={6}>
                    <TeamMatchSummaryView match={match} summaries={teamSummaries} />
                    {/* {parentCompetition ? (
                        <CompetitionStandingsList
                            titleView={
                                <Button
                                    variant="outline-dark"
                                    onClick={() => {
                                        history.push(`/competitions/${parentCompetition.id}`);
                                    }}
                                >
                                    {parentCompetition.attributes.name}
                                </Button>
                            }
                            competition={parentCompetition}
                        />
                    ) : (
                        <></>
                    )} */}
                </Col>
                <Col xs={12} sm={6}>
                    <MatchPlayerSummary match={match} playerSummaries={playerSummaries} allowsLinkToPlayerProfile={true} limit={3} />
                </Col>
            </Row>
        </>
    );
}
